import React, { useEffect, useState, createRef } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  CButton,
  CRow,
  CCol,
  CCard,
  CCardHeader,
  CCardBody,
  CTable,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CNavLink,
  CContainer,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CCallout,
  CSmartTable,
  CDropdownHeader,
  CDropdownItem,
  CTableBody,
  CTableRow,
  CTableDataCell,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'

import { cilSettings, cilAccountLogout, cilUserPlus } from '@coreui/icons'
import * as cusUtil from 'src/viewsCommon/CusUtil'
import CusResultModal from 'src/viewsCommon/CusResultModal'
import U_UserInputModal from './U_UserInputModal'

const U_UserDetailModal = (param) => {
  const navigate = useNavigate()

  const [visible, setVisible] = useState(false)
  const [data, setData] = useState({})

  const fetchData = async (isVisible) => {
    const url = '/cube_dev_local/api/user/user/v02/user/my'
    console.log('detail url: ', url)

    cusUtil
      .axiosGet(url)
      .then((response) => {
        console.log(response)

        setData(response.data)
        if (isVisible) {
          setVisible(!visible)
        }
      })
      .catch((error) => {
        console.error('user detail fail: ', error)
      })
  }

  const handleLogout = (event) => {
    cusUtil
      .axiosGet('/cube_dev_local/api/logout')
      .then((response) => {
        console.log(response)
      })
      .catch((error) => {
        console.log(error.response)
      })
      .finally(() => {
        cusUtil.setCookie('jwttoken', '', 0)
        cusUtil.setCookie('jwttokenRe', '', 0)
        navigate('/login')
      })
  }

  const handleLogin = (event) => {
    navigate('/login')
  }

  const TableData = () => {
    const userid = `${data.userid}`
    const name = `${data.name}`

    const dataList = data.userAuthDetailList
    const columns = [
      {
        key: 'show_title',
        label: '이름',
        _style: { minWidth: '130px' },
      },
      {
        key: 'authCdName',
        label: '권한',
        _style: { minWidth: '130px' },
      },
      {
        key: 'centerName',
        label: '센터',
        _style: { minWidth: '130px' },
      },
      {
        key: 'show_regDt',
        label: '등록일',
        _style: { minWidth: '130px' },
      },
      {
        key: 'show_details',
        label: '비고',
        _style: { minWidth: '130px' },
        filter: false,
        sorter: false,
      },
    ]

    return (
      <CCol xs={12}>
        <CCallout color="primary" className="p-10 mt-0 mb-1 border-radius-0">
          <div className="fs-7 text-medium-emphasis">나의 상세 정보 입니다.</div>
        </CCallout>
        <CCard className="mb-2">
          <CCardBody className="bg-opacity-100 px-0 py-6 small">
            <CTable small bordered align="middle" className="mb-0 border-05">
              <CTableBody>
                <CTableRow>
                  <CTableDataCell className="w-30 px-2">아이디</CTableDataCell>
                  <CTableDataCell className="px-2">{userid}</CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="px-2">이름</CTableDataCell>
                  <CTableDataCell className="px-2">{name}</CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="px-2">주소</CTableDataCell>
                  <CTableDataCell className="px-2">
                    {data.userDetailsList && data.userDetailsList.length > 0
                      ? data.userDetailsList[0].addr
                      : ''}
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="px-2">상세주소</CTableDataCell>
                  <CTableDataCell className="px-2">
                    {data.userDetailsList && data.userDetailsList.length > 0
                      ? data.userDetailsList[0].addrDetail
                      : ''}
                  </CTableDataCell>
                </CTableRow>
                <CTableRow>
                  <CTableDataCell className="px-2">회원가입일</CTableDataCell>
                  <CTableDataCell className="px-2">{cusUtil.getDtStr(data.regDt)}</CTableDataCell>
                </CTableRow>
              </CTableBody>
            </CTable>
          </CCardBody>
        </CCard>
      </CCol>
    )
  }

  const [isResultOpen, setIsResultOpen] = useState(false)
  const [resultTitle, setResultTitle] = useState('')
  const [resultBody, setResultBody] = useState('')

  const openResultModal = () => {
    setIsResultOpen(true)
  }

  const closeResultModal = () => {
    setIsResultOpen(false)
    // 로그인화면으로 이동
    navigate('/login')
  }

  const CusDeleteConfirm = (param) => {
    const [visible, setVisible] = useState(false)

    const handleOkClick = () => {
      setVisible(false)
      deleteData(param)
    }

    return (
      <>
        <CButton
          color="danger"
          size="sm"
          className="mx-1 text-white"
          onClick={() => setVisible(!visible)}
        >
          회원탈퇴
        </CButton>
        <CModal backdrop="static" visible={visible} onClose={() => setVisible(false)}>
          <CModalHeader>
            <CModalTitle>확인</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <div>{param.name}</div>
            <div className="my-2">탈퇴 하시겠습니까?</div>
          </CModalBody>
          <CModalFooter>
            <CButton
              color="dark"
              size="sm"
              className="mx-1 text-white"
              onClick={() => setVisible(false)}
            >
              취소
            </CButton>
            <CButton
              color="primary"
              size="sm"
              className="mx-1 text-white"
              onClick={() => handleOkClick()}
            >
              확인
            </CButton>
          </CModalFooter>
        </CModal>
      </>
    )
  }

  const deleteData = async ({ uid }) => {
    const url = '/cube_dev_local/api/user/user/v02/user/my/'
    console.log('delete url: ', url)

    cusUtil
      .axiosDelete(url)
      .then((response) => {
        console.log(response)
        const responseData = response.data

        if (responseData.resultYne == 'Y') {
          setResultTitle('확인')
          setResultBody('정상적으로 탈퇴 되었습니다.')
          openResultModal()
        } else {
          setResultTitle('에러')
          setResultBody('[' + responseData.resultYne + '] ' + responseData.resultMsg)
          openResultModal()
        }
      })
      .catch((error) => {
        console.error('user delete fail: ', error)
        setResultTitle('예외사항 발생')
        setResultBody('[' + error.code + '] ' + error.message)
        openResultModal()
      })
  }

  return (
    <>
      <CDropdownHeader className="bg-light dark:bg-white dark:bg-opacity-10 fw-semibold py-3">
        {param.title}
      </CDropdownHeader>

      {cusUtil.getJwtToken() !== '' && (
        <>
          <CDropdownItem
            role="button"
            className="text-medium-emphasis small"
            onClick={() => fetchData(true)}
          >
            <CIcon icon={cilSettings} className="me-2" />
            내정보관리
          </CDropdownItem>
          <CDropdownItem
            role="button"
            className="text-medium-emphasis small"
            onClick={handleLogout}
          >
            <CIcon icon={cilAccountLogout} className="me-2" />
            로그아웃
          </CDropdownItem>
        </>
      )}
      {cusUtil.getJwtToken() === '' && (
        <>
          <CDropdownItem
            role="button"
            className="text-medium-emphasis small"
            onClick={() => handleLogin(true)}
          >
            <CIcon icon={cilAccountLogout} className="me-2" />
            로그인
          </CDropdownItem>
          <CDropdownItem
            role="button"
            className="text-medium-emphasis small"
            onClick={handleLogout}
          >
            <CIcon icon={cilUserPlus} className="me-2" />
            간편회원가입
          </CDropdownItem>
        </>
      )}

      {/* <CNavLink role="button" onClick={() => fetchData(true)}>
        {param.title}
      </CNavLink> */}
      <CModal fullscreen backdrop="static" visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>상세정보</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <TableData />

          <CContainer>
            <CRow>
              <CCol align="center">
                <CusDeleteConfirm uid={data.userUid} />
                <CButton
                  color="dark"
                  size="sm"
                  className="mx-1 text-white"
                  onClick={() => setVisible(false)}
                >
                  닫기
                </CButton>
                <U_UserInputModal
                  btnTitle="수정"
                  titleHead="나의 정보수정"
                  info={data}
                  closeModalAction={fetchData}
                />
              </CCol>
            </CRow>
          </CContainer>
        </CModalBody>
      </CModal>

      <CusResultModal
        isOpen={isResultOpen}
        closeModal={closeResultModal}
        resultTitle={resultTitle}
        resultBody={resultBody}
      />
    </>
  )
}

export default U_UserDetailModal
